import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field, SubmissionError} from 'redux-form';
import {Form, FormGroup, Button} from 'reactstrap';
import {withTranslation} from 'react-i18next';

import {validate} from '../../../../../shared/src/modules/public/login/Login';
import {
  _login,
  _snackbarAcknowledgement
} from '../../../../../shared/src/store/actions/AuthActions';
import {
  loginAzureSSOService,
  loginService
} from '../../../../../shared/src/services/PublicService';
import AuthUtils from '../../../utils/AuthUtils';
import NavRoutes from '../../../constants/NavRoutes';
import InitSharedRepo from '../../../../../shared/index';

import LogoImage from '../../../assets/images/mpower-logo.png';
import bgLoginImage from '../../../assets/images/bg-login.png';
import FormTextInput from '../../../components/form/FormTextInput';
import './Login.scss';

import {environment} from '../../../../../shared/src/environment/environment';

import * as Msal from 'msal';

import ClipLoader from 'react-spinners/ClipLoader';
import { BASE_ROUTE } from '../../../constants/BaseRoute';
const msalConfig = {
  auth: {
    clientId: environment.azureClientId,
    authority: environment.azureAuthorityURI + environment.azureTenantId
  }
};

const msalInstance = new Msal.UserAgentApplication(msalConfig);

let Login = class Login extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoggedIn: false,
      loading: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAuthRedirect = this.handleAuthRedirect.bind(this);
    this.loginWithAzure = this.loginWithAzure.bind(this);
    this.acquireTokenAndLogin = this.acquireTokenAndLogin.bind(this);
    this.loginWithToken = this.loginWithToken.bind(this);
  }

  componentDidMount() {
    msalInstance.handleRedirectCallback((error: any, response: any) => {
      // handle redirect response or error
    });
  }

  toggleLoading(): void {
    this.setState((prevState: any) => ({
      loading: !prevState.loading
    }));
  }

  handleSubmit = async (values: any) => {
    // Values will be key value pairs (fieldName : fieldValue)
    // Validation can be done here also (while submitting), and error can be thrown
    const {t} = this.props;
    try {
      const errors = validate(values);
      if (Object.keys(errors).length) {
        // Handle Error
        throw new SubmissionError(errors);
      } else {
        // setting this property for admin login
        values.admin = true;
        const response = await loginService(values);
        if (response && response.token) {
          this.handleAuthRedirect(response.token, response.user);
        }
      }
    } catch (e) {
      const err = e as any;
      if (err && err.errors && err.errors.email) {
        this.props._snackbarAcknowledgement(
          true,
          err.errors.email,
          t('COMMON.WARNINGTEXT')
        );
      } else if (err && err.errors && err.errors.password) {
        this.props._snackbarAcknowledgement(
          true,
          err.errors.password,
          t('COMMON.WARNINGTEXT')
        );
      } else {
        this.props._snackbarAcknowledgement(
          true,
          t('COMMON.LOGINERROR'),
          t('COMMON.ERRORTEXT')
        );
      }
    }
  };

  loginWithAzure = () => {
    const {t} = this.props;
    try {
      this.toggleLoading();

      const loginRequest = {
        scopes: ['user.read', 'mail.send'],
        prompt: 'select_account'
      };

      msalInstance
        .loginPopup(loginRequest)
        .then((response: any) => {
          this.acquireTokenAndLogin();
        })
        .catch((err: any) => {
          this.props._snackbarAcknowledgement(
            true,
            t('COMMON.AZURELOGINERROR'),
            t('COMMON.ERRORTEXT')
          );
          this.toggleLoading();
        });
    } catch (e) {
      this.props._snackbarAcknowledgement(
        true,
        t('COMMON.AZURELOGINERROR'),
        t('COMMON.ERRORTEXT')
      );
      this.toggleLoading();
    }
  };

  acquireTokenAndLogin() {
    const {t} = this.props;
    if (msalInstance.getAccount()) {
      const tokenRequest = {
        scopes: ['user.read', 'mail.send']
      };

      msalInstance
        .acquireTokenSilent(tokenRequest)
        .then(async (response: any) => {
          this.loginWithToken(response);
        })
        .catch((error: any) => {
          if (error.name === 'InteractionRequiredAuthError') {
            msalInstance
              .acquireTokenPopup(tokenRequest)
              .then((response: any) => {
                this.loginWithToken(response);
              })
              .catch((err: any) => {
                this.props._snackbarAcknowledgement(
                  true,
                  t('COMMON.AZURELOGINERROR'),
                  t('COMMON.ERRORTEXT')
                );
                this.toggleLoading();
              });
          } else {
            this.toggleLoading();
          }
        });
    } else {
      // user is not logged in, you will need to log them in to acquire a token
      this.toggleLoading();
    }
  }

  async loginWithToken(response: any) {
    const {t} = this.props;
    if (!response || !response.accessToken) {
      this.props._snackbarAcknowledgement(
        true,
        t('COMMON.AZURELOGINERROR'),
        t('COMMON.ERRORTEXT')
      );
      this.toggleLoading();
      return;
    }

    const res = {
      accessToken: response.accessToken,
      refreshToken: response.accessToken,
      idToken: response.idToken.rawIdToken
    };

    const appBackendRes = await loginAzureSSOService(
      res.accessToken,
      res.refreshToken,
      res.idToken,
      true
    );

    if (appBackendRes.status) {
      if (appBackendRes.user && appBackendRes.user.display_name) {
        appBackendRes.user.name = appBackendRes.user.display_name;
      } else {
        appBackendRes.user.name =
          appBackendRes.user.first_name + ' ' + appBackendRes.user.last_name;
      }

      this.handleAuthRedirect(appBackendRes.token, appBackendRes.user);
      this.toggleLoading();
    } else {
      this.props._snackbarAcknowledgement(
        true,
        'Unable to sign in with microsoft!',
        t('COMMON.ERRORTEXT')
      );
      this.toggleLoading();
    }
  }

  handleAuthRedirect(token: any, user: any) {
    const {t} = this.props;
    InitSharedRepo.initAfterAuth(token);
    AuthUtils.clearPatientAuthToken();
    AuthUtils.setAuthToken(token);
    AuthUtils.setUser(user);
    this.props._login(token);
    this.props.history.push(
      `/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}`
    );
    this.props._snackbarAcknowledgement(
      true,
      'You are successfully logged in',
      t('COMMON.SUCCESS')
    );
  }

  changeLanguages = (values: any) => {
    const {i18n} = this.props;
    i18n.changeLanguage(values);
  };

  render() {
    const {t} = this.props;
    return (
      <div className={'login-wrapper'}>
        <div className={'columnContainer'}>
          <div className={'leftContainer'}>
            <div className={'titleContainer'}>
              <div>
                <img src={LogoImage} style={{width: '48%'}} />
              </div>
              <div className={'loginContainer'}>
                <span className={'adminLoginText'}>
                  {t('LOGIN.ADMINLOGIN')}
                </span>
              </div>
              <div className={'subTitleContainer'}>
                <div className={'subTitleText'}>{t('LOGIN.MPOWER_INFO')}</div>
                <div className={'subTitleText'}>
                  {' ' + t('LOGIN.MPOWER_INFO_TEXT')}
                </div>
              </div>
              <div className={'buttonContainer'}>
                <Form>
                  <FormGroup>
                    <Field
                      name="email"
                      placeholder={t('LOGIN.EMAIL')}
                      component={FormTextInput}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Field
                      name="password"
                      type="password"
                      placeholder={t('LOGIN.PASSWORD')}
                      component={FormTextInput}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Button
                      color="primary"
                      size="md"
                      type="submit"
                      block
                      onClick={this.props.handleSubmit(this.handleSubmit)}>
                      <span className={'loginText'}>{t('LOGIN.TITLE')}</span>
                    </Button>
                  </FormGroup>
                  <div style={{textAlign: 'center'}}>
                    <span className={'adminLoginText'}>{t('COMMON.OR')}</span>
                  </div>
                  <FormGroup>
                    <Button
                      color="primary"
                      block
                      onClick={this.loginWithAzure}
                      className="azureLoginButton"
                      disabled={this.state.loading}>
                      {this.state.loading && (
                        <div className="loader">
                          <ClipLoader size={20} color={'white'} />
                        </div>
                      )}
                      <span className={'loginText'}>
                        {'Sign In With Microsoft'}
                      </span>
                    </Button>
                  </FormGroup>
                </Form>
              </div>
            </div>
          </div>
          <div
            style={{backgroundImage: `url(${bgLoginImage})`}}
            className="right-ontainer">
            <div className={'tagLineContainer'}>
              <div className={'tagLineText'}>{t('LOGIN.EMPOWERING')}</div>
              <div className={'tagLineText'}> {t('LOGIN.BETTER')}</div>
              <div className={'tagLineText'}>
                {t('LOGIN.HEALTH_CARE') + '.'}
              </div>
              <div style={{marginTop: '5%'}}>
                <div className={'subTagLineText'}>
                  {t('LOGIN.INNOVATIVE_COST_EFFECT')}
                </div>
                <div className={'subTagLineText'}>{t('LOGIN.OUTCOMES')}</div>
              </div>
              <div className={'labelContainer'}>
                <div className={'orangeLabelFirstPart'} />
                <div className={'orangeLabelRemainingPart'} />
                <div className={'orangeLabelRemainingPart'} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

// @ts-ignore
Login = reduxForm({
  form: 'login' // Will be available in redux form state by this name
  // @ts-ignore
})(Login);

// Connecting component with redux state
// @ts-ignore
Login = connect(
  () => ({
    x: 'y'
  }),
  {
    _login,
    _snackbarAcknowledgement
  }
)(Login);

export default withTranslation()(Login);
